module.exports = __webpack_public_path__ + "static/media/iconSend.ff514170.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/iconSend.svg
// module id = 954
// module chunks = 0